import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BillingService } from 'src/app/shared/services/billing/billing.service';
import { HelpService } from 'src/app/shared/services/help.service';
import { ShipmentMasterService } from 'src/app/shared/services/shipment-master.service';
import { AuthService } from "../../../../shared/services/auth.service";


@Component({
    selector: 'app-manual-benchmark-dialog',
    templateUrl: './manual-benchmark-dialog.component.html',
    styleUrls: ['./manual-benchmark-dialog.component.scss'],
    standalone: false
})
export class ManualBenchmarkDialogComponent implements OnInit {

  isLoading = false;
  manualBenchmarkForm: FormGroup;

  constructor(
    private readonly dialogRef: MatDialogRef<ManualBenchmarkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      shipmentId: number,
      loadId: number,
      amount: number
    },
    private readonly formBuilder: FormBuilder,
    private readonly helpService: HelpService,
    private readonly billingService: BillingService,
    private readonly shipmentMasterService: ShipmentMasterService,
    private readonly authService: AuthService
  ) { }

  ngOnInit() {
    this.createManualBenchmarkForm();
  }

  createManualBenchmarkPricesheet(): void {
    this.isLoading = true;
    const formData = {
      ShipmentId: Number(this.manualBenchmarkForm.value.ShipmentId),
      Amount: Number(this.manualBenchmarkForm.value.Amount),
      CreateUser: this.authService.userEmail
    };
    this.billingService.createManualBenchmarkPricesheet(formData).subscribe({
      next: () => {
        this.helpService.showMessageNotification('Manual Benchmark successfull created', 'success');
        this.isLoading = false;
        this.shipmentMasterService.getShipmentAndLoad(this.data.shipmentId, this.data.loadId);
        this.dialogRef.close(true);
      },
      error: () => {
        this.helpService.showMessageNotification('Error! Please try again.', 'danger');
        this.isLoading = false;
      }
    });
  }

  createManualBenchmarkForm(): void {
    this.manualBenchmarkForm = this.formBuilder.group({
      ShipmentId: [this.data.shipmentId, Validators.required],
      Amount: [this.data.amount, Validators.required]
    });
  }

}
